import { Component, Input, AfterViewInit, AfterViewChecked, OnInit } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { v1 as uuid } from 'uuid';

declare var jQuery: any;

@Component({
  selector: 'app-tooltip-enabled-markup',
  templateUrl: './tooltip-enabled-markup.component.html',
  styleUrls: ['./tooltip-enabled-markup.component.scss']
})
export class TooltipEnabledMarkupComponent implements OnInit, AfterViewInit {

  @Input()
  public html: string;
  public id: string;

  public trustedHtml: SafeHtml;

  constructor(public sanitizer: DomSanitizer) {
    this.generateId();
  }

  ngOnInit(): void {
    this.trustedHtml = this.sanitizer.bypassSecurityTrustHtml(this.html);
  }

  ngAfterViewInit(): void {
    this.initOevdToolTips();
  }

  generateId(): void {
    this.id = uuid();
  }

  initOevdToolTips(): void {
    (($) => {
        const parentEl = $('#' + this.id);
        const foundElements = parentEl.find("[data-oev-tooltip]");
        if (foundElements.length > 0 && foundElements.oevTooltip) foundElements.oevTooltip()
    })(jQuery);
  }

}
